import React, { HTMLAttributes } from 'react';
import { Box, media, xcss } from '@atlaskit/primitives';

const styles = xcss({
  height: '100%',
  marginTop: '0',
  marginBottom: '0',
  marginLeft: 'space.0',
  marginRight: 'space.0',
  [media.above.sm]: {
    marginLeft: 'space.400',
    marginRight: 'space.400',
  },
  [media.above.md]: {
    marginLeft: 'space.800',
    marginRight: 'space.800',
  },
  [media.above.lg]: {
    marginLeft: 'space.1000',
    marginRight: 'space.1000',
  },
});

export const PageWrapper = (attributes: HTMLAttributes<object>) => <Box as='div' {...attributes} xcss={styles} />;

PageWrapper.displayName = 'PageWrapper';
